import React from "react";
import PropTypes from "prop-types";
// import styled from 'styled-customComponents';
import withStyles from "@material-ui/core/styles/withStyles";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
// @material-ui/icons
import Close from "@material-ui/icons/Close";
// core components
import Button from "components/CustomButtons/Button";

import modalStyle from "assets/jss/material-kit-pro-react/modalStyle";

// eslint-disable-next-line react/display-name
const Transition = React.forwardRef((props, ref) => (
	<Slide direction="down" ref={ref} {...props} />
));

const ClubIncompleteDialog = ({ classes, open, onClose }) => {
	//const [open, setOpen] = useState(false);

	const handleClose = () => {
		onClose();
	};

	//const { classes } = props;

	return (
		<div>
			{open && (
				<Dialog
					classes={{
						root: classes.modalRoot,
						paper: classes.modal,
					}}
					open={open}
					TransitionComponent={Transition}
					keepMounted
					onClose={() => handleClose()}
					aria-labelledby="classic-modal-slide-title"
					aria-describedby="classic-modal-slide-description"
				>
					<DialogTitle
						id="classic-modal-slide-title"
						disableTypography
						className={classes.modalHeader}
					>
						<Button
							simple
							className={classes.modalCloseButton}
							key="close"
							aria-label="Close"
							onClick={() => handleClose()}
						>
							{" "}
							<Close className={classes.modalClose} />
						</Button>
						<h4 className={classes.modalTitle}>Verein nicht vollständig</h4>
					</DialogTitle>
					<DialogContent
						id="classic-modal-slide-description"
						className={classes.modalBody}
					>
						Dein Verein ist aktuell nicht vollständig. Damit ein Verein in der
						Solingen Sportapp angezeigt wird müssen ein Logo, eine Beschreibung
						und eine vollständige Adresse vorhanden sein.
					</DialogContent>
					<DialogActions className={classes.modalFooter}>
						<Button
							color="primary"
							onClick={() => {
								handleClose();
							}}
						>
							OK
						</Button>
					</DialogActions>
				</Dialog>
			)}
		</div>
	);
};

ClubIncompleteDialog.propTypes = {
	classes: PropTypes.object,
	objectId: PropTypes.string,
	open: PropTypes.bool,
	onClose: PropTypes.func,
};

export default withStyles(modalStyle)(ClubIncompleteDialog);
